import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Alert, Button, Form, Input, Layout } from 'antd'
import * as React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from 'src/context/UserContext'
import { setLoggedUserProps } from 'src/util/Util'
import { StorageKey } from '../../util/Storage'
import accountApi from '../app/account/AccountApi'
import './style.css'

const FormItem = Form.Item

export const LoginForm: React.FC = () => {

    const [form] = Form.useForm()
    const [unauthorized, setUnauthorized] = useState(false)
    const { setUser } = useUser()
    const navigateTo = useNavigate()

    const handleSubmit = async () => {
        const values = await form.validateFields()
        const success = await accountApi.login(values.username, values.password)
        if (success) {
            setLoggedUserProps(setUser)
            navigateTo('/')
        } else {
            setUnauthorized(true)
        }
    }

    return <Layout>
        <Form onFinish={handleSubmit} className="login-form" form={form}>
            <FormItem name="username" >
                <Input prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
            </FormItem>
            <FormItem name="password" >
                <Input prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} type="password"
                    placeholder="Password" />
            </FormItem>
            <FormItem>
                <Button type="primary" htmlType="submit" className="login-form-button">
                    Log in
                </Button>
            </FormItem>
            {unauthorized ? <Alert message={`${localStorage.getItem(StorageKey.ApiError)}`} type="error" /> : null}
        </Form>
    </Layout>
}


// WEBPACK FOOTER //
// ./src/component/loginForm/LoginForm.tsx